export default {
    checkbox: 'type-to-do',
    text: 'type-description',
    done: 'type-done',
    failed: 'type-failed',
    waiting: 'type-waiting',
    idea: 'type-idea',
    cancelled: 'type-cancelled'
}
